<template>
  <div class="popup-timer-not-started">
    <div class="left">
      <UIButton
        :ghost="true"
        class="editbooking"
        @click="$emit('editBooking')"
      >{{ $t("Edit Reservation") }}</UIButton>
    </div>
    <div class="right">
      <UIButton icon="play" class="start" @click="start" v-if="lengthHMS">{{ $t('Start') }}</UIButton>
      <div class="info" v-if="lengthHMS">
        <div class="length">
          <div class="label f8">{{ $t('Length') }}</div>
          <span class="f5">{{ lengthHMS }}</span>
        </div>
        <div class="endsat">
          <div class="label f8">{{ $t('Ends At') }}</div>
          <span class="f5">{{ endsAt }}</span>
        </div>
      </div>
      <div class="nolength f6" v-if="!lengthHMS">
        <span class="title f4">{{ $t("This reservation already ended.") }}</span>
        <br>
        {{ $t("If you want to start, please edit the reservation so it will end after the current time.") }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
  },
})
export default class BookingDetailNotStarted extends Vue {
  get diff () {
    // Diff will positive if early, negative if late
    return moment(this.startTime).diff(moment(this.currentTime));
  }

  get lengthMilliseconds () {
    return this.length * 60 * 1000;
  }

  get lengthHMS () {
    // Length is always in minutes, so we have to make it milli's by timesing it by 60 and then 1000
    let lengthHMS;
    if (this.diff > 0) {
      lengthHMS = DateHelper.formatMillisecondsToHMS(this.lengthMilliseconds);
    } else {
      lengthHMS = DateHelper.formatMillisecondsToHMS(this.lengthMilliseconds + this.diff);
    }
    // If length has a dash at the start that means it's past the endTime. So don't show it.
    if (lengthHMS.slice(0, 1) !== '-') return lengthHMS;
  }

  get endsAt () {
    if (this.diff > 0) {
      return moment(this.endTime).subtract(this.diff, 'milliseconds').format('LT');
    } else {
      return moment(this.endTime).format('LT');
    }
  }

  start () {
    this.$emit('start');
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.popup-timer-not-started {
  @media (--tablet) {
    display: flex;
    align-items: flex-start;
    padding: 0;
  }

  & .left {
    display: flex;
    flex: 1 1 50%;
    padding: var(--spacingSm) 0 0 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .editbooking {
      flex: 1 1 auto;
      margin-left: auto;
    }
  }

  & .right {
    display: flex;
    flex: 1 1 50%;
    align-items: center;
    padding: var(--spacingSm) 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .start {
      flex: 1 1 15rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: var(--spacingSm);
      align-self: flex-start;
      background: var(--colorSuccess);

      &:hover {
        background: var(--colorSuccessHover);
      }

      & svg {
        fill: var(--colorWhite);
        height: 1.6rem;
        width: 1.6rem;
        margin-right: var(--spacingXS);
      }
    }

    & .nolength {
      color: var(--colorManatee);
      margin: 0;

      & .title {
        text-align: center;
        margin-top: 0;
        color: var(--colorSlate);
      }
    }

    & .info {
      flex: 1 1 auto;
      display: flex;

      & .label {
        margin-bottom: var(--spacingXS);
      }

      & > div {
        flex: 1 1 auto;
      }
    }
  }
}
</style>
